<fm-map-menu-container
  [menuData]="menuData"
  [userPermissions]="userMenuPermissions$ | async"
  *ngIf="menuType === EMapContextMenuType.Map"
  (closed)="closeMenu()"
  (findNearestClicked)="openFindNearest()"
  (driverDispatchClicked)="openDriverDispatch()"
  (createGeofenceClicked)="openCreateGeofence()"
  (getDirectionToClicked)="openGetDirectionTo()"
  (getDirectionFromClicked)="openGetDirectionFrom()"
  (locationToGarminClicked)="openLocationToGarmin($event)"
  (streetViewClicked)="openStreetView()"
  (zoomToClicked)="zoomTo()"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
></fm-map-menu-container>

<fm-vehicle-menu-container
  [menuData]="menuData"
  [userPermissions]="userMenuPermissions$ | async"
  [isPingMVPEnabled]="isPingMVPEnabled$ | async"
  *ngIf="menuType === EMapContextMenuType.Vehicle && menuData.markerInfo"
  (closed)="closeMenu()"
  (findNearestClicked)="openFindNearest()"
  (viewReplayClicked)="openVehicleReplay()"
  (runDailyReportClicked)="openRunDailyReport()"
  (runDetailedReportClicked)="openRunDetailedReport()"
  (zoomToClicked)="zoomTo()"
  (streetViewClicked)="openStreetView()"
  (createGeofenceClicked)="openCreateGeofenceForVehicle()"
  (removeFromLiveMapClicked)="removeFromLiveMap()"
  (getDirectionToClicked)="openGetDirectionToVehicle()"
  (getDirectionFromClicked)="openGetDirectionFromVehicle()"
  (editDriverClicked)="openEditDriver()"
  (editVehicleClicked)="openEditVehicle()"
  (sendMessageClicked)="openSendDriverMessage()"
  (sendStopClicked)="sendStop()"
  (roadsideAssistanceClicked)="roadsideAssistance()"
  (viewStopsClicked)="viewStops()"
  (viewMessagesClicked)="openViewMessages()"
  (locationToGarminClicked)="openLocationToGarmin($event)"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
  (troubleshootVehicleClicked)="troubleshootVehicle()"
>
</fm-vehicle-menu-container>

<fm-geofence-menu-container
  [menuData]="menuData"
  [userPermissions]="userMenuPermissions$ | async"
  *ngIf="menuType === EMapContextMenuType.Geofence && menuData.markerInfo"
  (closed)="closeMenu()"
  (findNearestClicked)="openFindNearest()"
  (zoomToClicked)="zoomTo()"
  (streetViewClicked)="openStreetView()"
  (editPlaceClicked)="openEditPlace()"
  (getDirectionToClicked)="openGetDirectionTo()"
  (getDirectionFromClicked)="openGetDirectionFrom()"
  (locationToGarminClicked)="openLocationToGarmin($event)"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
>
</fm-geofence-menu-container>

<fm-hotspot-menu-container
  [menuData]="menuData"
  [userPermissions]="userMenuPermissions$ | async"
  *ngIf="menuType === EMapContextMenuType.Hotspot"
  (closed)="closeMenu()"
  (findNearestClicked)="openFindNearest()"
  (zoomToClicked)="zoomTo()"
  (streetViewClicked)="openStreetView()"
  (editPlaceClicked)="openEditPlace()"
  (getDirectionToClicked)="openGetDirectionTo()"
  (getDirectionFromClicked)="openGetDirectionFrom()"
  (locationToGarminClicked)="openLocationToGarmin($event)"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
>
</fm-hotspot-menu-container>

<fm-garmin-menu-container
  [menuData]="menuData"
  [userPermissions]="userMenuPermissions$ | async"
  *ngIf="menuType === EMapContextMenuType.Garmin"
  (closed)="closeMenu()"
  (findNearestClicked)="openFindNearest()"
  (zoomToClicked)="zoomTo()"
  (streetViewClicked)="openStreetView()"
  (createGeofenceClicked)="openCreateGeofence()"
  (dispatchWindowClicked)="openDispatchWindow()"
  (viewStatusHistoryClicked)="openViewStatusHistory()"
  (getDirectionToClicked)="openGetDirectionTo()"
  (getDirectionFromClicked)="openGetDirectionFrom()"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
>
</fm-garmin-menu-container>

<fm-work-order-menu-container
  [menuData]="menuData"
  [userPermissions]="userMenuPermissions$ | async"
  *ngIf="menuType === EMapContextMenuType.WorkOrder && menuData.markerInfo"
  (closed)="closeMenu()"
  (findNearestClicked)="openFindNearest()"
  (zoomToClicked)="zoomTo()"
  (streetViewClicked)="openStreetView()"
  (editWorkOrderClicked)="openEditWorkOrder()"
  (workOrderDetailsClicked)="openWorkOrderDetails()"
  (workOrderStatusHistoryClicked)="openWorkOrderStatusHistory()"
  (getDirectionToClicked)="openGetDirectionTo()"
  (getDirectionFromClicked)="openGetDirectionFrom()"
  (locationToGarminClicked)="openLocationToGarmin($event)"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
>
</fm-work-order-menu-container>

<fm-asset-menu-container
  [menuData]="menuData"
  [userPermissions]="userMenuPermissions$ | async"
  [isPingMVPEnabled]="isPingMVPEnabled$ | async"
  *ngIf="menuType === EMapContextMenuType.Asset && menuData.markerInfo"
  (closed)="closeMenu()"
  (findNearestClicked)="openFindNearest()"
  (viewReplayClicked)="openAssetReplay()"
  (locationHistoryClicked)="openLocationHistory()"
  (zoomToClicked)="zoomTo()"
  (streetViewClicked)="openStreetView()"
  (createGeofenceClicked)="openCreateGeofence()"
  (getDirectionToClicked)="openGetDirectionTo()"
  (getDirectionFromClicked)="openGetDirectionFrom()"
  (editAssetClicked)="openEditAsset($event)"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
  (troubleshootAssetClicked)="troubleshootAsset()"
>
</fm-asset-menu-container>

<ng-template #coordinatesCopiedContentTemplate i18n="@@S_COORD_COPIED"> Coordinates copied to clipboard </ng-template>
